import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import TimePicker from 'rc-time-picker';
import moment from 'moment';

import radioChecked from '../../common/Images/radio_button_checked.svg';
import radioUnchecked from '../../common/Images/radio_button_unchecked.svg';

import { RANGE_FILTER_TYPES } from '@silverfort-nodelibs/common/utils/consts';

class DateFilter extends Component {
    state = {
        startDate: moment().subtract(1, 'd'),
        endDate: moment(),
        startTime: moment().startOf('h'),
        endTime: moment().add(1, 'h').endOf('h').add(1, 's'),
        rangeType: this.props.value
    };

    componentDidMount() {
        if (!this.props.value) {
            this.changeToUnix();
        } else if (this.props.value[0] === RANGE_FILTER_TYPES.CUSTOM_RANGE.value) {
            this.setState({
                rangeType: this.props.value[0],
                startDate: moment.unix(this.props.value[1]),
                startTime: moment.unix(this.props.value[1])
            });
            if (this.props.value[2]) {
                this.setState({
                    rangeType: this.props.value[0],
                    endDate: moment.unix(this.props.value[2]),
                    endTime: moment.unix(this.props.value[2])
                });
            }
        } else {
            this.setState({
                rangeType: this.props.value[0]
            });
        }
    }

    startDateChanged = (newDate) => {
        if (!newDate) {
            return;
        }

        const newDateAsMoment = moment(newDate);

        if (this.state.endDate && newDateAsMoment && this.state.endDate < newDateAsMoment) {
            this.setState({ startDate: this.state.endDate, endDate: newDateAsMoment }, () => this.changeToUnix());
        } else {
            this.setState({ startDate: newDateAsMoment }, () => this.changeToUnix());
        }
    };

    startTimeChanged = (newTime) => {
        this.setState({ startTime: newTime }, () => this.changeToUnix());
    };

    endTimeChanged = (newTime) => {
        this.setState({ endTime: newTime }, () => this.changeToUnix());
    };

    endDateChanged = (newDate) => {
        if (!newDate) {
            return;
        }

        const newDateAsMoment = moment(newDate);

        if (this.state.startDate && newDateAsMoment && this.state.startDate > newDateAsMoment) {
            this.setState({ endDate: this.state.startDate, startDate: newDateAsMoment }, () => this.changeToUnix());
        } else {
            this.setState({ endDate: newDateAsMoment }, () => this.changeToUnix());
        }
    };

    changeToUnix() {
        if (this.state.rangeType !== RANGE_FILTER_TYPES.CUSTOM_RANGE.value) {
            return this.props.changed(this.state.rangeType);
        }
        let startDate = null;
        if (this.state.startDate && this.state.startTime) {
            startDate = moment
                .utc(
                    this.state.startDate
                        .hour(this.state.startTime.hour())
                        .minute(this.state.startTime.minute())
                        .second(this.state.startTime.second())
                        .format()
                )
                .unix();
        }

        let endDate = null;
        if (this.state.endDate && this.state.endTime) {
            endDate = moment
                .utc(
                    this.state.endDate
                        .hour(this.state.endTime.hour())
                        .minute(this.state.endTime.minute())
                        .second(this.state.endTime.second())
                        .format()
                )
                .unix();
        }

        this.props.changed(this.state.rangeType, startDate, endDate);
    }

    onRangeTypeChange = (event, newVal) => {
        this.setState({ rangeType: newVal }, () => {
            this.changeToUnix();
        });
    };
    render() {
        const allowedRangeTypes = Object.values(RANGE_FILTER_TYPES).filter(
            (rangeType) => !this.props.notAllowedRangeTypes.includes(rangeType.value)
        );
        const rangeTypesOptions = allowedRangeTypes.map((option) => {
            return (
                <div
                    key={`rangeOption_${option.value}`}
                    id={`rangeOption_${option.value}`}
                    className="p-1.5 text-normal cursor-pointer flex items-center"
                    onClick={(event) => this.onRangeTypeChange(event, option.value)}>
                    {option.value === this.state.rangeType && <img src={radioChecked} alt="" />}
                    {option.value !== this.state.rangeType && <img src={radioUnchecked} alt="" />}
                    <div className="mx-1.5">{option.label}</div>
                </div>
            );
        });
        return (
            <div className="items-center">
                <div>{rangeTypesOptions}</div>
                {this.state.rangeType === RANGE_FILTER_TYPES.CUSTOM_RANGE.value && (
                    <div className="customRangeContainer">
                        <div className="customRangeSelector">
                            <div className="py-1 px-1.5">
                                <label className="font-semibold mb-0.5" htmlFor="startDate">
                                    From:
                                </label>
                                <div className="flex">
                                    <DatePicker
                                        className="pt-2 px-2 w-[110px] border-b border-stone-300"
                                        id="startDate"
                                        selected={this.state.startDate.toDate()}
                                        value={this.state.startDate.toDate()}
                                        selectsStart
                                        startDate={this.state.startDate.toDate()}
                                        endDate={this.state.endDate.toDate()}
                                        utcOffset={moment().utcOffset()}
                                        onChange={this.startDateChanged.bind(this)}
                                        nextMonthButtonLabel
                                        previousMonthButtonLabel
                                    />
                                    <TimePicker
                                        id="startTime"
                                        className="ml-6 pt-1.5 w-[110px] border-b border-stone-300"
                                        inputClassName="outline-none border-none"
                                        allowEmpty={false}
                                        value={this.state.startTime}
                                        onChange={this.startTimeChanged.bind(this)}
                                    />
                                </div>
                            </div>
                            <div className="py-1 px-1.5">
                                <label className="font-semibold mb-0.5" htmlFor="endDate">
                                    To:
                                </label>
                                <div className="flex">
                                    <DatePicker
                                        id="endDate"
                                        className="px-2 pt-2 w-[110px] border-b border-stone-300"
                                        selected={this.state.endDate.toDate()}
                                        value={this.state.endDate.toDate()}
                                        selectsEnd
                                        startDate={this.state.startDate.toDate()}
                                        endDate={this.state.endDate.toDate()}
                                        utcOffset={moment().utcOffset()}
                                        onChange={this.endDateChanged.bind(this)}
                                        nextMonthButtonLabel
                                        previousMonthButtonLabel
                                    />
                                    <TimePicker
                                        id="endTime"
                                        className="ml-6 pt-1.5 w-[110px] border-b border-stone-300"
                                        inputClassName="outline-none border-none"
                                        allowEmpty={false}
                                        value={this.state.endTime}
                                        onChange={this.endTimeChanged.bind(this)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default DateFilter;
